<template>
    <base-layout>
        <div
            :style="formWrapExtraStyle"
            class="form-wrap"
        >
            <slot name="header" />
            <slot name="content" />
            <slot name="footer">
                <div slot="footer" class="version-wrap">
                    <version />
                </div>
            </slot>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from '../Layout/BaseLayout';
import Version from '@/components/Version';

export default {
    name: 'AuthLayout',
    components: {
        BaseLayout,
        Version,
    },
    props: {
        minHeight: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {};
    },
    computed: {
        formWrapExtraStyle() {
            if (this.minHeight) {
                return {
                    'min-height': this.minHeight
                };
            } else {
                return '';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import './authLayout.scss';

.form-wrap {
  width: $formWrapWidth;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 0px 12px rgba(139, 154, 175, .15);
  margin: 0 auto;
  margin-top: 50px;
  position: relative;
  padding: 30px 68px;
  box-sizing: border-box;
}

::v-deep .el-tabs__content {
  overflow: inherit;
}

::v-deep .el-tabs__nav-wrap::after {
  background: #fff;
}

::v-deep .el-tabs__active-bar {
  display: none;
}

::v-deep .el-tabs__item {
  font-size: 16px;
  color: #222;
  font-weight: 400;
}

::v-deep .el-tabs__item.is-active {
  color: #B81B22;
}

::v-deep .el-input__inner {
  border: 0;
  border-bottom: 1px solid rgba(228, 231, 237, 1);
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
  color: #222;
  font-size: 14px;
}

::v-deep .el-input-group__append {
  background: #fff;
  border: 0;
  border-bottom: 1px solid rgb(228, 231, 237);
  padding: 0;
  border-radius: 0;
}
::v-deep .is-error .el-input-group__append {
  border-bottom: 1px solid #F56C6C;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

.version-wrap {
  position: absolute;
  left: 0;
  bottom: -64px;
  width: 100%;
}
</style>
